
webpack.register(
    'components/dfp-advert-unit/dfp-advert-unit',
    function() {
        return require('components/dfp-advert-unit/dfp-advert-unit');
    },
    false
);
webpack.register(
    'components/custom-merchandise/custom-merchandise',
    function() {
        return require('components/custom-merchandise/custom-merchandise');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dfp-advert-unit/dfp-advert-unit'/>\r\n<can-import from='components/custom-merchandise/custom-merchandise'/>\r\n\r\n{{#if renderMerchandiseUnit}}\r\n    {{#if products}}\r\n        <div class=\"s-video-right-rail-sponsor-container__item s-video-right-rail-sponsor-container__item--merchandise\">\r\n            <custom-merchandise {merchandise}=\"products\" {cta-link}=\"productsCtaLink\"></custom-merchandise>\r\n        </div>\r\n    {{/if}}\r\n{{else}}\r\n    <div class=\"s-video-right-rail-sponsor-container__item s-video-right-rail-sponsor-container__item--dfp-advert-unit\">\r\n        <dfp-advert-unit {ad-unit-path}=\"adUnitPath\"\r\n                         {sizes}=\"adSizes\"\r\n                         {reload-interval}=\"adReloadInterval\"\r\n                         (didnotrender)=\"onAdDidNotRender()\">\r\n        </dfp-advert-unit>\r\n    </div>\r\n{{/if}}\r\n");